import React from "react";
import InputField from "../../SharedComponent/Fields/InputField";
import { useTranslation } from "react-i18next";
import SelectField from "../../SharedComponent/Fields/SelectField";
import TextAreaFielD from "../../SharedComponent/Fields/TextareaField";
import { ImagePlus, Upload, X } from "lucide-react";
import { getAttachmentLargeUrl, getAttachmentThumbUrl, getAttachmentDocumentUrl } from "../../utils/attachmentImages";
import TextareaField from "../../SharedComponent/Fields/TextareaField";

const ConstructionMachinery = ({
  formatAttachment,
  handleDeleteAttachment,
  assetAttachments,
  newAsset,
  handleChange,
  warehouses,
  selectedWarehouse,
  handleWarehouseChange,
  warehouseLocationId,
  selectedFiles,
  handleRemoveFile,
  handleFileChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Basics Section */}
      <div className="bg-white p-4 shadow-md">
        <h2 className="text-xl font-medium mb-3 text-gray-800">
          {t("assetPageHeadings.basics")}
        </h2>

        {/* Row 1: Classification, Manufacturer, Type, Serial No */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
          <SelectField
            name="construction_classification"
            value={newAsset.construction_classification}
            onChange={handleChange}
            label={t("assets.fields.classification")}
            explanation={t("assets.fields.explanation.classification")}
            placeholder={t("assets.fields.selectClassification")}
            required
            menus={[
              {
                value: "",
                option: t("constructionMachinery.classificationTypes.select"),
              },
              {
                value: 2,
                option: t(
                  "constructionMachinery.classificationTypes.hydraulicExcavators"
                ),
              },
              {
                value: 3,
                option: t(
                  "constructionMachinery.classificationTypes.wheelExcavator"
                ),
              },
              {
                value: 4,
                option: t(
                  "constructionMachinery.classificationTypes.miniExcavator"
                ),
              },
              {
                value: 5,
                option: t(
                  "constructionMachinery.classificationTypes.demolitionExcavator"
                ),
              },
              {
                value: 6,
                option: t(
                  "constructionMachinery.classificationTypes.rehandlingExcavator"
                ),
              },
              {
                value: 7,
                option: t(
                  "constructionMachinery.classificationTypes.draglineExcavator"
                ),
              },
              {
                value: 8,
                option: t(
                  "constructionMachinery.classificationTypes.roadRailExcavator"
                ),
              },
              {
                value: 10,
                option: t(
                  "constructionMachinery.classificationTypes.wheelLoader"
                ),
              },
              {
                value: 11,
                option: t(
                  "constructionMachinery.classificationTypes.compactLoader"
                ),
              },
              {
                value: 12,
                option: t(
                  "constructionMachinery.classificationTypes.materialHandlingLoader"
                ),
              },
              {
                value: 14,
                option: t(
                  "constructionMachinery.classificationTypes.rigidBackhoeLoader"
                ),
              },
              {
                value: 15,
                option: t(
                  "constructionMachinery.classificationTypes.articulatedBackhoeLoader"
                ),
              },
              {
                value: 16,
                option: t(
                  "constructionMachinery.classificationTypes.miniBackhoeLoader"
                ),
              },
              {
                value: 18,
                option: t(
                  "constructionMachinery.classificationTypes.bulldozer"
                ),
              },
              {
                value: 19,
                option: t(
                  "constructionMachinery.classificationTypes.crawlerLoader"
                ),
              },
              {
                value: 20,
                option: t(
                  "constructionMachinery.classificationTypes.pipelayingCaterpillar"
                ),
              },
              {
                value: 21,
                option: t("constructionMachinery.classificationTypes.weldBead"),
              },
              {
                value: 23,
                option: t("constructionMachinery.classificationTypes.grader"),
              },
              {
                value: 24,
                option: t(
                  "constructionMachinery.classificationTypes.selfPoweredScraper"
                ),
              },
              {
                value: 25,
                option: t(
                  "constructionMachinery.classificationTypes.trailedScraper"
                ),
              },
              {
                value: 26,
                option: t(
                  "constructionMachinery.classificationTypes.scrapedozer"
                ),
              },
              {
                value: 28,
                option: t(
                  "constructionMachinery.classificationTypes.articulatedDumpTruck"
                ),
              },
              {
                value: 29,
                option: t(
                  "constructionMachinery.classificationTypes.rigidDumpTruck"
                ),
              },
              {
                value: 30,
                option: t(
                  "constructionMachinery.classificationTypes.miniDumper"
                ),
              },
              {
                value: 31,
                option: t(
                  "constructionMachinery.classificationTypes.trackedDumper"
                ),
              },
              {
                value: 33,
                option: t(
                  "constructionMachinery.classificationTypes.mobileCrane"
                ),
              },
              {
                value: 34,
                option: t(
                  "constructionMachinery.classificationTypes.truckCrane"
                ),
              },
              {
                value: 35,
                option: t(
                  "constructionMachinery.classificationTypes.crawlerCrane"
                ),
              },
              {
                value: 36,
                option: t(
                  "constructionMachinery.classificationTypes.towerCrane"
                ),
              },
              {
                value: 37,
                option: t(
                  "constructionMachinery.classificationTypes.selfErectingCrane"
                ),
              },
              {
                value: 38,
                option: t(
                  "constructionMachinery.classificationTypes.mobileConstructionCrane"
                ),
              },
              {
                value: 39,
                option: t(
                  "constructionMachinery.classificationTypes.docksideCrane"
                ),
              },
              {
                value: 40,
                option: t(
                  "constructionMachinery.classificationTypes.miniCrane"
                ),
              },
              {
                value: 41,
                option: t(
                  "constructionMachinery.classificationTypes.auxiliaryCrane"
                ),
              },
              {
                value: 43,
                option: t(
                  "constructionMachinery.classificationTypes.singleDrumCompactor"
                ),
              },
              {
                value: 44,
                option: t(
                  "constructionMachinery.classificationTypes.asphaltCompactorTandem"
                ),
              },
              {
                value: 45,
                option: t(
                  "constructionMachinery.classificationTypes.combiRoller"
                ),
              },
              {
                value: 46,
                option: t(
                  "constructionMachinery.classificationTypes.pneumaticCompactor"
                ),
              },
              {
                value: 47,
                option: t(
                  "constructionMachinery.classificationTypes.sheepsfootRoller"
                ),
              },
              {
                value: 48,
                option: t(
                  "constructionMachinery.classificationTypes.landfillCompactor"
                ),
              },
              {
                value: 49,
                option: t(
                  "constructionMachinery.classificationTypes.towedRoller"
                ),
              },
              {
                value: 51,
                option: t(
                  "constructionMachinery.classificationTypes.truckMixer"
                ),
              },
              {
                value: 52,
                option: t(
                  "constructionMachinery.classificationTypes.concreteScrewConveyor"
                ),
              },
              {
                value: 53,
                option: t(
                  "constructionMachinery.classificationTypes.truckConcretePump"
                ),
              },
              {
                value: 54,
                option: t(
                  "constructionMachinery.classificationTypes.concretePump"
                ),
              },
              {
                value: 56,
                option: t(
                  "constructionMachinery.classificationTypes.wheeledPaver"
                ),
              },
              {
                value: 57,
                option: t(
                  "constructionMachinery.classificationTypes.trackedPaver"
                ),
              },
              {
                value: 58,
                option: t(
                  "constructionMachinery.classificationTypes.asphaltPlaner"
                ),
              },
              {
                value: 59,
                option: t(
                  "constructionMachinery.classificationTypes.surfaceMiner"
                ),
              },
              {
                value: 60,
                option: t(
                  "constructionMachinery.classificationTypes.asphaltRecycler"
                ),
              },
              {
                value: 61,
                option: t(
                  "constructionMachinery.classificationTypes.soilStabilizer"
                ),
              },
              {
                value: 62,
                option: t(
                  "constructionMachinery.classificationTypes.coldRecycler"
                ),
              },
              {
                value: 63,
                option: t(
                  "constructionMachinery.classificationTypes.hotRecycler"
                ),
              },
              {
                value: 64,
                option: t(
                  "constructionMachinery.classificationTypes.slipformPaver"
                ),
              },
              {
                value: 65,
                option: t("constructionMachinery.classificationTypes.gritter"),
              },
              {
                value: 67,
                option: t(
                  "constructionMachinery.classificationTypes.drillingMachine"
                ),
              },
              {
                value: 68,
                option: t(
                  "constructionMachinery.classificationTypes.anchorDrillRig"
                ),
              },
              {
                value: 69,
                option: t("constructionMachinery.classificationTypes.drillRig"),
              },
              {
                value: 70,
                option: t(
                  "constructionMachinery.classificationTypes.blastholeDrill"
                ),
              },
              {
                value: 71,
                option: t(
                  "constructionMachinery.classificationTypes.trenchCutter"
                ),
              },
              {
                value: 72,
                option: t(
                  "constructionMachinery.classificationTypes.diphragmGrabWall"
                ),
              },
              {
                value: 73,
                option: t(
                  "constructionMachinery.classificationTypes.depthVibrator"
                ),
              },
              {
                value: 74,
                option: t(
                  "constructionMachinery.classificationTypes.chainTrencher"
                ),
              },
              {
                value: 76,
                option: t(
                  "constructionMachinery.classificationTypes.universalPillingRig"
                ),
              },
              {
                value: 77,
                option: t(
                  "constructionMachinery.classificationTypes.pilingHammer"
                ),
              },
              {
                value: 79,
                option: t("constructionMachinery.classificationTypes.drilling"),
              },
              {
                value: 80,
                option: t(
                  "constructionMachinery.classificationTypes.tunnelDumper"
                ),
              },
              {
                value: 81,
                option: t(
                  "constructionMachinery.classificationTypes.tunnelLoader"
                ),
              },
              {
                value: 82,
                option: t(
                  "constructionMachinery.classificationTypes.tunnelExcavator"
                ),
              },
              {
                value: 83,
                option: t(
                  "constructionMachinery.classificationTypes.sprayConcretePump"
                ),
              },
              {
                value: 84,
                option: t(
                  "constructionMachinery.classificationTypes.tunnelTruckMixer"
                ),
              },
              {
                value: 85,
                option: t(
                  "constructionMachinery.classificationTypes.tunnelingShield"
                ),
              },
              {
                value: 86,
                option: t(
                  "constructionMachinery.classificationTypes.roadheader"
                ),
              },
              {
                value: 88,
                option: t(
                  "constructionMachinery.classificationTypes.miningExcavator"
                ),
              },
              {
                value: 89,
                option: t(
                  "constructionMachinery.classificationTypes.miningDumper"
                ),
              },
              {
                value: 91,
                option: t("constructionMachinery.classificationTypes.others"),
              },
              {
                value: 93,
                option: t(
                  "constructionMachinery.classificationTypes.attachments"
                ),
              },
              {
                value: 94,
                option: t(
                  "constructionMachinery.classificationTypes.powerGenerator"
                ),
              },
              {
                value: 95,
                option: t(
                  "constructionMachinery.classificationTypes.pileDriving"
                ),
              },
              {
                value: 96,
                option: t(
                  "constructionMachinery.classificationTypes.compressor"
                ),
              },
              {
                value: 98,
                option: t("constructionMachinery.classificationTypes.trailer"),
              },
              {
                value: 100,
                option: t("constructionMachinery.classificationTypes.truck"),
              },
              {
                value: 101,
                option: t(
                  "constructionMachinery.classificationTypes.plateCompactor"
                ),
              },
              {
                value: 102,
                option: t("constructionMachinery.classificationTypes.ramps"),
              },
            ]}
            selectClassName={
    !newAsset.construction_classification
      ? "text-gray-400 font-light"
      : "text-gray-900 font-normal"
  }
          />

          <InputField
            name="manufacturer"
            value={newAsset.manufacturer}
            onChange={handleChange}
            required
            label={t("assets.fields.manufacturer")}
            explanation={t("assets.fields.explanation.manufacturer")}
            placeholder={t("createAsset.placeholder.enterManufacturer")}
            maxLength={100}
          />

          <InputField
            name="type"
            value={newAsset.type}
            onChange={handleChange}
            label={t("assets.fields.type")}
            placeholder={t("createAsset.placeholder.enterType")}
            explanation={t("assets.fields.explanation.type")}
            maxLength={100}
          />

          <InputField
            name="serial_no"
            value={newAsset.serial_no}
            onChange={handleChange}
            placeholder={t("createAsset.placeholder.enterSerialNumber")}
            explanation={t("assets.fields.serialNumber")}
            label={t("assets.fields.machineSerialNo")}
            maxLength={100}
          />
        </div>

        {/* Row 2: Internal No, Status, Engine Type, Year */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 mt-2">
          <InputField
            name="construction_internalno"
            value={newAsset.construction_internalno}
            onChange={handleChange}
            label={t("createAsset.placeholders.internNoLabel")}
            explanation={t("createAsset.placeholders.internNoExplanation")}
            placeholder={t("createAsset.placeholders.internNoPlaceholder")}
            maxLength={100}
          />

          <SelectField
            name="status"
            value={newAsset.status}
            onChange={handleChange}
            label={t("assets.fields.status")}
            placeholder={t("createAsset.placeholder.enterStatus")}
            explanation={t("assets.fields.explanation.status")}
            required
            menus={[
              { value: "", option: t("assets.fields.selectStatus") },
              { value: "New", option: t("assets.options.new") },
              { value: "Used", option: t("assets.options.used") },
              { value: "Demo", option: t("assets.options.demo") },
            ]}
          />

          <SelectField
            name="construction_enginetype"
            value={newAsset.construction_enginetype}
            onChange={handleChange}
            label={t("createAsset.placeholders.engineTypeLabel")}
            explanation={t("createAsset.placeholders.engineTypeExplanation")}
            placeholder={t("createAsset.placeholders.engineTypePlaceholder")}
            menus={[
              { value: "", option: t("workPlatform.placeholders.engineType")},
              { value: 1, option: t("assets.options.diesel") },
              { value: 2, option: t("assets.options.electric") },
              { value: 3, option: t("assets.options.lpg") },
              { value: 4, option: t("assets.options.gasoline-gas") },
              { value: 5, option: t("assets.options.hybrid") },
              { value: 6, option: t("assets.options.fuel-cell") },
              { value: 7, option: t("assets.options.lithium-ion") },
              { value: 8, option: t("assets.options.hand") },
            ]}
          />
          <div>
            <InputField
              name="operating_hours"
              type="number"
              value={newAsset.operating_hours}
              onChange={handleChange}
              label={t("assets.fields.operatingHours")}
              explanation={t("assets.fields.explanation.operatingHours")}
              placeholder={t("cleaningEquipment.placeholders.operatingHours")}
              maxLength={8}
            />
          </div>
        </div>

        {/* Row 5: Container Volume, Weight, Dimensions */}
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 mt-2">
          <InputField
            name="cleaning_length"
            type="number"
            value={newAsset.construction_length}
            onChange={handleChange}
            label={t("constructionMachinery.fields.length")}
            explanation={t("constructionMachinery.explanations.length")}
            placeholder={t("cleaningEquipment.placeholders.length")}
          />

          <InputField
            name="cleaning_width"
            type="number"
            value={newAsset.construction_width}
            onChange={handleChange}
            label={t("constructionMachinery.fields.width")}
            explanation={t("constructionMachinery.explanations.width")}
            placeholder={t("cleaningEquipment.placeholders.width")}
          />

          <InputField
            name="cleaning_height"
            type="number"
            value={newAsset.construction_height}
            onChange={handleChange}
           label={t("constructionMachinery.fields.height")}
            explanation={t("constructionMachinery.explanations.height")}
            placeholder={t("cleaningEquipment.placeholders.height")}
          />
          <InputField
            name="construction_weight"
            type="number"
            value={newAsset.construction_weight}
            onChange={handleChange}
           label={t("constructionMachinery.fields.weight")}
            explanation={t("constructionMachinery.explanations.weight")}
            placeholder={t("cleaningEquipment.placeholders.weight")}
          />
          <InputField
            name="sparepart_available"
            type="date"
            value={newAsset.sparepart_available}
            onChange={handleChange}
            label={t("constructionMachinery.fields.availableFrom")}
            explanation={t("constructionMachinery.explanations.availableFrom")}
            placeholder={t("cleaningEquipment.placeholders.availableFrom")}
          />
        </div>

        {/* Row 6: Condition, Battery, Commission, Available From */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2">
          <SelectField
            name="technical_condition"
            value={newAsset.technical_condition}
            onChange={handleChange}
            label={t("createAsset.placeholders.technicalConditionLabel")}
            explanation={t(
              "createAsset.placeholders.technicalConditionExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.technicalConditionPlaceholder"
            )}
            menus={[
              {
                value: "",
                option: t(
                  "createAsset.placeholders.technicalConditionPlaceholder"
                ),
              },
              {
                value: 2,
                option: t("assets.technicalCondition.very_good"),
              },
              {
                value: 3,
                option: t("assets.technicalCondition.good"),
              },
              {
                value: 4,
                option: t("assets.technicalCondition.used"),
              },
              {
                value: 5,
                option: t("assets.technicalCondition.bad"),
              },
              {
                value: 6,
                option: t("assets.technicalCondition.very_bad"),
              },
              {
                value: 7,
                option: t("assets.technicalCondition.new"),
              },
            ]}
          />
          <SelectField
            name="optical_condition"
            value={newAsset.optical_condition}
            onChange={handleChange}
            label={t("createAsset.placeholders.opticalConditionLabel")}
            explanation={t(
              "createAsset.placeholders.opticalConditionExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.opticalConditionPlaceholder"
            )}
            menus={[
              {
                value: "",
                option: t(
                  "createAsset.placeholders.opticalConditionPlaceholder"
                ),
              },
              {
                value: 2,
                option: t("assets.opticalCondition.very_good"),
              },
              { value: 3, option: t("assets.opticalCondition.good") },
              { value: 4, option: t("assets.opticalCondition.used") },
              { value: 5, option: t("assets.opticalCondition.bad") },
              { value: 6, option: t("assets.opticalCondition.very_bad") },
              { value: 7, option: t("assets.opticalCondition.new") },
            ]}
          />
          <InputField
            name="year_of_manufacture"
            value={newAsset.year_of_manufacture || ""}
            onChange={handleChange}
            label={t("assets.fields.yearOfManufacture")}
            explanation={t("assets.fields.explanation.yearOfManufacture")}
            placeholder={t("createAsset.placeholder.enterYearOfManufacture")}
            type="year"
            maxLength={100}
          />
        </div>

        {/* Row 7: Warehouse + Address */}
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 mt-2">
          {Array.isArray(warehouses) && warehouses?.length > 0 && (
            <SelectField
              name="warehouse"
              value={selectedWarehouse?.id || warehouseLocationId || ""}
              onChange={handleWarehouseChange}
              label="Warehouse"
              menus={[
                { value: "", option: "Select Warehouse" },
                ...warehouses.map((w) => ({ value: w.id, option: w.name })),
              ]}
            />
          )}

          <div>
            <InputField
              required
              name="dealer_street"
              value={newAsset.dealer_street}
              onChange={handleChange}
              maxLength={20}
              label={t("createAsset.placeholders.street")}
              placeholder={t("createAsset.placeholders.streetPlaceholder")}
              explanation={t("createAsset.placeholders.streetExplanation")}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_city"
              value={newAsset.dealer_city}
              onChange={handleChange}
              label={t("createAsset.placeholders.city")}
              explanation={t("createAsset.placeholders.cityExplanation")}
              placeholder={t("createAsset.placeholders.cityPlaceholder")}
              maxLength={50}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_country"
              value={newAsset.dealer_country}
              onChange={handleChange}
              label={t("createAsset.placeholders.country")}
              explanation={t("createAsset.placeholders.countryExplanation")}
              placeholder={t("createAsset.placeholders.countryPlaceholder")}
              maxLength={50}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_zip"
              value={newAsset.dealer_zip}
              onChange={handleChange}
              type="number"
              label={t("createAsset.placeholders.zipCode")}
              explanation={t("createAsset.placeholders.zipCodePlaceholder")}
              placeholder={t("createAsset.placeholders.zipCodeExplanation")}
              maxLength={7}
            />
          </div>
        </div>

        {/* Description */}
        <div className="mt-2">
          <TextareaField
            name="description"
            value={newAsset.description}
            onChange={handleChange}
            label={t("createAsset.placeholders.additionalDescription")}
            placeholder={t(
              "createAsset.placeholders.additionalDescriptionPlaceholder"
            )}
          />
        </div>
      </div>

      {/* Media Upload Section */}
      <div className="bg-white p-4 shadow-md mt-4">
        <h2 className="text-xl font-medium mb-3 text-gray-800">Media</h2>

        {/* Selected Files */}
        {selectedFiles?.length > 0 && (
          <div className="space-y-2 mt-2">
            <h6>Selected Media</h6>
            <ul className="space-y-1 flex flex-col gap-3">
              {Array.from(selectedFiles).map((file, index) => (
                <li key={index} className="flex items-center gap-4">
                  {file.type.startsWith("image/") && (
                    <img
                      className="h-10 w-10"
                      alt={`cleaning ${index}`}
                      src={URL.createObjectURL(file)}
                    />
                  )}
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-sm font-semibold underline ml-2"
                  >
                    {file.name}
                  </a>
                  <div
                    onClick={() => handleRemoveFile(index)}
                    className="cursor-pointer"
                  >
                    <X className="h-5 w-5" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Uploaded Media */}
        {assetAttachments?.length > 0 && (
          <div className="flex flex-col gap-2 mt-4">
            <h6>Uploaded Media</h6>
            <div className="flex flex-col gap-3">
              {assetAttachments.map((attachment, index) => (
                <div key={index} className="flex items-center gap-2">
                  {attachment?.image ? (
                    <>
                      <img
                        className="h-10 w-10"
                        src={getAttachmentThumbUrl(attachment)}
                        alt="cleaning equipment"
                      />
                      <a
                        href={getAttachmentLargeUrl(attachment)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 text-sm font-semibold underline ml-2"
                      >
                        {formatAttachment(getAttachmentLargeUrl(attachment))}
                      </a>
                    </>
                  ) : (
                    <a
                      href={getAttachmentDocumentUrl(attachment)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 text-sm font-semibold underline ml-2"
                    >
                      {formatAttachment(getAttachmentDocumentUrl(attachment))}
                    </a>
                  )}
                  <div
                    onClick={() => handleDeleteAttachment(attachment?.id)}
                    className="cursor-pointer"
                  >
                    <X className="h-5 w-5" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* File Upload */}
        <div className="my-4">
          <div className="relative">
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              accept="image/*, .xlsx, .xls, .doc, .docx, .pdf"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              id="cleaning-upload"
            />
            <label
              htmlFor="cleaning-upload"
              className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 hover:border-gray-400"
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <div className="flex items-center space-x-2 mb-2">
                  <Upload className="w-6 h-6 text-gray-400" />
                  <ImagePlus className="w-6 h-6 text-gray-400" />
                </div>
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">
                    {t("assetPageHeadings.clickToUpload")}
                  </span>
                </p>
                <p className="text-xs text-gray-400">
                  {t("assetPageHeadings.fileSupported")}
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConstructionMachinery;
